// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgHelp24 = forwardRef(({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
	let ariaLabelledBy = titleid ? titleid : "";
	ariaLabelledBy += desc && descid ? ` ${descid}` : "";
	ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
	props["aria-labelledby"] = ariaLabelledBy;
	return (
		<Svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
			title={title}
			titleid={titleid}
			desc={desc}
			descid={descid}
			aria-labelledby={ariaLabelledBy}
			aria-hidden={!ariaLabelledBy}
			ref={ref}
			{...props}
		>
			{!!title && <title id={titleId}>{title}</title>}
			{!!desc && <desc id={descId}>{desc}</desc>}
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3ZM12 4.5C7.85786 4.5 4.5 7.85786 4.5 12C4.5 16.1421 7.85786 19.5 12 19.5C16.1421 19.5 19.5 16.1421 19.5 12C19.5 7.85786 16.1421 4.5 12 4.5ZM12 16C12.5523 16 13 16.4477 13 17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17C11 16.4477 11.4477 16 12 16ZM12.2127 7C12.8415 7 13.3971 7.11717 13.8795 7.35152C14.3619 7.58587 14.7349 7.91758 14.9985 8.34664C15.2621 8.77571 15.3939 9.26697 15.3939 9.82043C15.3939 10.202 15.3347 10.548 15.2162 10.8583C15.0976 11.1687 14.9281 11.4453 14.7075 11.6881C14.531 11.8823 14.3227 12.0609 14.0827 12.2237L13.8967 12.343C13.5916 12.5292 13.3514 12.7191 13.1762 12.9127C13.001 13.1063 12.872 13.3366 12.7891 13.6035C12.7062 13.8703 12.662 14.2029 12.6564 14.6011V14.6984H11.1613V14.6011C11.1669 13.9841 11.2297 13.4847 11.3497 13.1029C11.4696 12.7211 11.6356 12.4149 11.8475 12.1842C12.0171 11.9997 12.2337 11.8178 12.4972 11.6387L12.7037 11.5048C12.9276 11.3658 13.1201 11.2142 13.2815 11.05C13.4428 10.8858 13.569 10.6999 13.6601 10.4923C13.7511 10.2846 13.7967 10.0571 13.7967 9.80967C13.7967 9.51157 13.7272 9.24983 13.5883 9.02444C13.4494 8.79905 13.258 8.62488 13.0142 8.50195C12.7704 8.37902 12.5019 8.31755 12.2088 8.31755C11.9355 8.31755 11.6795 8.37471 11.4408 8.48904C11.2021 8.60337 11.0053 8.77815 10.8504 9.01339C10.6956 9.24863 10.6069 9.53998 10.5845 9.88744H9C9.02093 9.28149 9.17511 8.76131 9.46252 8.3269C9.74993 7.89249 10.1331 7.56274 10.612 7.33764C11.0909 7.11255 11.6244 7 12.2127 7Z"
			/>
		</Svg>
	);
});
SvgHelp24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgHelp24;
